import { NavigateExternalInlineIcon } from "@fluentui/react-icons-mdl2";
import { Link } from "@fluentui/react/lib/Link";
import { TooltipHost } from "@fluentui/react/lib/Tooltip";

import { FilterToolTipContent } from "Components/Generic/FilterToolTipContent";
import { WithTranslator } from "Components/Generic/Translator";
import { isNullOrWhiteSpace } from "Utils/String";
import { TooltipCloseDelay, TooltipOpenDelay } from "../TooltipSettings";
import { IUrlRendererProps } from "./IUrlRendererProps";
import { useUrlRendererStyles } from "./UseUrlRendererStyles";

export const UrlRenderer = WithTranslator((props: IUrlRendererProps): JSX.Element => {
  const {
    fieldName, item, translator, styles
  } = props;
  const url = item?.[fieldName]?.toString();
  const styleSet = useUrlRendererStyles(styles);

  if (isNullOrWhiteSpace(url)) {
    return null;
  }

  return (
    <TooltipHost
      delay={TooltipOpenDelay}
      closeDelay={TooltipCloseDelay}
      content={(
        <FilterToolTipContent
          fieldName={fieldName}
          value={translator.get(`tooltip.openexternal`, `Opens the exported record in an external window.`)}
          rawValue="@notnull@"
        />
      )}
      hostClassName={styleSet.host}
    >
      <div className={styleSet.root}>
        <Link
          as="a"
          href={url}
          target="_blank"
          alt={translator.get(`tooltip.openexternal`, `Opens the exported record in an external window.`)}
        >
          <NavigateExternalInlineIcon className={styleSet.icon} />
        </Link>
      </div>
    </TooltipHost>
  );
});
